<template>
  <crud-form
    v-model="payload"
    :page-title="getPageTitle"
    :request-class="requestClass"
    :total-group="1"
    navigate-back-route="template.list"
    navigate-page-after-save="template.list"
  >
    <template slot="group-1">
      <form-group title="Informações do template">
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:dscTemplate"
              v-model="payload.dscTemplate"
              :rules="[requiredRule]"
              label="Descritivo template"
              :loading="loading"
              required
            />
          </v-col>
          <v-col cols="6">
            <input-select
              id="input:idEmpresa"
              v-model="payload.idEmpresa"
              :rules="[requiredRule]"
              :items="idEmpresaOptions"
              label="Empresa"
              :loading="loading"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-select
              id="input:indPadrao"
              v-model="payload.indPadrao"
              :rules="[requiredRule]"
              :items="indPadraoOptions"
              label="Template padrão"
              :loading="loading"
              required
            />
          </v-col>
          <v-col
            v-if="payload.id"
            cols="6"
          >
            <input-text
              id="input:id"
              v-model="payload.id"
              label="Código"
              :loading="loading"
              disabled
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';
import httpService from '@/app/arch/services/HttpService';
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import TemplateRequest from 'Modules/contacard/produto/templates/TemplateRequest';

export default {
  name: 'TemplatesForm',
  components: { FormGroup, CrudForm },
  mixins: [RulesMixin, NotificationMixin],
  data: () => ({
    requestClass: TemplateRequest,
    requestCompany: httpService,
    isActive: null,
    loading: false,
    payload: {
      dscTemplate: '',
      idEmpresa: '',
      indPadrao: '',
      templateProdutoServicos: [],
    },
    idEmpresaOptions: [],
    indPadraoOptions: [
      {
        value: true,
        text: 'Sim',
      },
      {
        value: false,
        text: 'Não',
      },
    ],
    tipoValorTemplateOptions: [
      {
        value: 'F',
        text: 'Fixo',
      },
      {
        value: 'P',
        text: 'Percentual',
      },
    ],
    tipoComissaoTemplateOptions: [
      {
        value: 'M',
        text: 'Margem',
      },
      {
        value: 'T',
        text: 'Taxa',
      },
    ],
  }),
  computed: {
    getTemplateId() {
      return this.$route.params.id;
    },
    getPageTitle() {
      return this.getTemplateId ? 'Editar template' : 'Adicionar template';
    },
  },
  watch: {
    'payload.id': {
      handler(value) {
        this.isActive = value;
      },
    },
  },
  beforeMount() {
    this.makeRequests();
  },
  methods: {
    makeRequests() {
      this.getCompanies();
    },
    getCompanies() {
      this.makeCompanieRequest();
    },
    makeCompanieRequest() {
      this.requestCompany.get('/produto-servico/empresa/list-all', {
        params: {
          PerPage: 1000,
          page: 1,
        },
      })
        .then(({ data }) => {
          this.setCompanieOptions(data.data);
        }).catch(({ response }) => {
          this.setCompanieMessageError(response.data.message);
        });
    },
    setCompanieOptions(data) {
      this.idEmpresaOptions = data.map((item) => ({
        value: item.id,
        text: item.nomEmpresa,
      }));
    },
    setCompanieMessageError(message) {
      this.showMessageError(
        message || 'Falha ao buscar empresas',
      );
    },
    showMessageError(message) {
      this.showErrorToast({
        text: message,
      });
    },
    handleLoading(bool) {
      this.loading = bool;
    },
  },
  provide() {
    return {
      setDataLoading: this.handleLoading,
    };
  },
};
</script>
